<template>
  <div v-if="data.class === 'textarea'">
    <v-textarea
      prepend-icon="mdi-form-textbox"
      :label="data.text"
      v-model="data.value"
      :hint="data.placeholder"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
    ></v-textarea>
  </div>
  <div v-else-if="data.class === 'html'" class="mb-4">
    <div class="d-flex">
      <v-icon size="30" left>mdi-code-tags</v-icon>
      <div>
        <p class="subtitle-2 grey--text text--darken-1 mb-0 mt-3" v-text="data.text"></p>
        <p class="text-caption mb-2 grey--text text--darken-1" v-text="data.placeholder"></p>
      </div>
    </div>
    <div>
      <codemirror class="code-codemirror" v-model="data.value" :options="cmOptions" />
    </div>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";

// base style
import "codemirror/lib/codemirror.css";
// theme css
import "codemirror/theme/base16-dark.css";
// language
import "codemirror/mode/vue/vue.js";
// active-line.js
import "codemirror/addon/selection/active-line.js";
// styleSelectedText
import "codemirror/addon/selection/mark-selection.js";
import "codemirror/addon/search/searchcursor.js";
// highlightSelectionMatches
import "codemirror/addon/scroll/annotatescrollbar.js";
import "codemirror/addon/search/matchesonscrollbar.js";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/match-highlighter.js";
// keyMap
import "codemirror/mode/clike/clike.js";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/comment/comment.js";
import "codemirror/addon/dialog/dialog.js";
import "codemirror/addon/dialog/dialog.css";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/search.js";
import "codemirror/keymap/sublime.js";
// foldGutter
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/brace-fold.js";
import "codemirror/addon/fold/comment-fold.js";
import "codemirror/addon/fold/foldcode.js";
import "codemirror/addon/fold/foldgutter.js";
import "codemirror/addon/fold/indent-fold.js";
import "codemirror/addon/fold/markdown-fold.js";
import "codemirror/addon/fold/xml-fold.js";

export default {
  name: "Textarea",
  components: {
    codemirror
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    cmOptions: {
      tabSize: 4,
      foldGutter: true,
      styleActiveLine: true,
      lineNumbers: true,
      line: true,
      keyMap: "sublime",
      mode: "text/html",
      theme: "base16-dark",
      extraKeys: {
        F11(cm) {
          cm.setOption("fullScreen", !cm.getOption("fullScreen"));
        },
        Esc(cm) {
          if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
        }
      }
    }
  })
};
</script>

<style lang="scss" scoped>
.example {
  display: flex;
  height: 100%;
  .codemirror,
  .pre {
    width: 50%;
    height: 100%;
    margin: 0;
    overflow: auto;
  }
  .pre {
    display: block;
    padding: 1rem;
    font-size: 15px;
    line-height: 1.6;
    word-break: break-all;
    word-wrap: break-word;
  }
}
</style>

<style>
.CodeMirror * {
  font-size: 14px;
}
.code-icon {
  height: 100%;
}
</style>